import { Component } from 'react';
import {connect} from "react-redux";
import AbsenceForm from "./AbsenceForm";
import {withRouter} from 'react-router-dom'
import {compose} from 'redux'
import { setAbsenceDetails } from '../../redux/absences/absencesActions'

class EditAbsence extends Component {

    constructor(props){
        super(props);

        if(props.absenceDetails.length === 0)
            props.history.push("/absences");
    }

    render() {
        return (
            <div>
                <AbsenceForm readonly={this.props.absences.absenceCreationFields.status !== 'new'}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        absenceDetails: state.absences.absenceDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setAbsenceDetails: (details) => dispatch(setAbsenceDetails(details)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(EditAbsence);
